export function tagPath(tag: string): string {
  return `/articles/tags/${encodeURIComponent(tag.toLowerCase())}`;
}
